import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import
{
    CommodityCodeLookupViewModel,
    CommodityCodeViewModel,
    ExecutionResult,
    ICommodityCodeLookupService,
    ICommodityCodeService,
    LookupCriteria,
} from "@tylertech/tyler-api-types";

/**
 * TODO - This should be generated with the ExpressService attribute in Tyler.Api
 */
@Injectable()
export class CommodityCodeService implements ICommodityCodeService, ICommodityCodeLookupService
{
    private readonly $apiService = inject(ApiService);


    GetCode(id?: string): Promise<ExecutionResult<CommodityCodeViewModel>>
    {
        return this.$apiService.sendAuth("Tyler/API/AccountsPayable/Services/ICommodityCodeService/GetCode", id);
    }

    Lookup(criteria: LookupCriteria): Promise<ExecutionResult<CommodityCodeLookupViewModel[]>>
    {
        return this.$apiService.sendAuth(
            "Tyler/API/AccountsPayable/Services/Lookup/ICommodityCodeLookupService/Lookup",
            criteria
        );
    }
}
